import { useTimeZone, useUsers } from '@connect-x-app/hybrid-state';
import { FlightRoomUser, FlightRoomUserStatus, MessageStatus } from '@connect-x-app/shared-domain-models';
import { Iso8601DateString } from '@connect-x-app/shared-types';
import { getCustomCrewTitle, getIconForUser, UserUtil } from '@connect-x-app/shared-utils';
import { FlightroomInfoItem, MessageStatusIcon, StatusDot } from '@connect-x-app/web-ui';

type Props = {
  crewMember: FlightRoomUser;
  messageDeliveryStatus?: MessageStatus;
  onClick?: (user: FlightRoomUser) => void;
  receiptUpdatedAt?: Iso8601DateString;
};

export const CrewMemberInfoItem = ({ crewMember, messageDeliveryStatus, onClick, receiptUpdatedAt }: Props) => {
  const { getUserByExternalId } = useUsers();
  const { formatTimeInTimeZone } = useTimeZone();

  const user = getUserByExternalId(crewMember.externalId);
  const icon = getIconForUser({ crewMember, user });
  const customCrewTitle = getCustomCrewTitle(crewMember.jobTitle, crewMember.jobTitleCustom);

  return (
    <FlightroomInfoItem
      avatar={icon}
      onClick={onClick && user && crewMember ? () => onClick?.(crewMember) : undefined}
      rightSection={<StatusDot size="small" status={user?.connectivityStatus} userId={user?.externalId} />}
      subValue={receiptUpdatedAt ? formatTimeInTimeZone(receiptUpdatedAt) : ''}
      title={
        crewMember.status === FlightRoomUserStatus.SCHEDULED
          ? (customCrewTitle ?? UserUtil.getDivision(crewMember.jobTitle))
          : UserUtil.getGuestUserString(crewMember.jobTitle ?? user?.jobTitle, customCrewTitle)
      }
      titleIcon={messageDeliveryStatus ? <MessageStatusIcon status={messageDeliveryStatus} /> : null}
      value={UserUtil.getFullName(user ?? crewMember)}
    />
  );
};
